var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fm-generate-form',{ref:"generateForm",attrs:{"data":_vm.jsonData,"value":_vm.formData},on:{"on-change":_vm.onChange}}),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleSubmit}},[_vm._v("提交")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }